
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CheckSubcontractorForExistingAccountRequest,
  CheckSubcontractorForExistingAccountResult,
} from '../models';
import {
    CheckSubcontractorForExistingAccountRequestFromJSON,
    CheckSubcontractorForExistingAccountRequestToJSON,
    CheckSubcontractorForExistingAccountResultFromJSON,
    CheckSubcontractorForExistingAccountResultToJSON,
} from '../models';

export interface CheckSubcontractorForExistingAccountOperationRequest {
    checkSubcontractorForExistingAccountRequest: CheckSubcontractorForExistingAccountRequest;
}

/**
 * 
 */
export class SubcontractorInfosApi extends runtime.BaseAPI {

    /**
     * Check for existing subcontractor
          */
    async checkSubcontractorForExistingAccountRaw(requestParameters: CheckSubcontractorForExistingAccountOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CheckSubcontractorForExistingAccountResult>> {
        if (requestParameters['checkSubcontractorForExistingAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'checkSubcontractorForExistingAccountRequest',
                'Required parameter "checkSubcontractorForExistingAccountRequest" was null or undefined when calling checkSubcontractorForExistingAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<CheckSubcontractorForExistingAccountResult>({
            path: `/repatriation-opportunity/api/repatriation-opportunity-groups/subcontractor-check`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CheckSubcontractorForExistingAccountRequestToJSON(requestParameters['checkSubcontractorForExistingAccountRequest']),
        }, initOverrides);

        if (response._data) { response._data=CheckSubcontractorForExistingAccountResultFromJSON(response._data); }
        return response;
    }

    /**
     * Check for existing subcontractor
          */
    async checkSubcontractorForExistingAccount(requestParameters: CheckSubcontractorForExistingAccountOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CheckSubcontractorForExistingAccountResult> {
        const response = await this.checkSubcontractorForExistingAccountRaw(requestParameters, initOverrides);
        return response._data;
    }

}
